/* global axios */
import ApiClient from '../ApiClient';

class CaptainFaqLearning extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  basePath(assistantId) {
    return `${this.url}/${assistantId}/faq_learning`;
  }

  suggestions({ assistantId, page = 1, perPage = 25, status, search } = {}) {
    return axios.get(`${this.basePath(assistantId)}/suggestions`, {
      params: { page, per_page: perPage, status, search },
    });
  }

  observations({ assistantId, page = 1, perPage = 25, status, search } = {}) {
    return axios.get(`${this.basePath(assistantId)}/observations`, {
      params: { page, per_page: perPage, status, search },
    });
  }

  suggestion({
    assistantId,
    suggestionId,
    observationsPage = 1,
    observationsPerPage = 25,
    observationStatus,
  }) {
    return axios.get(
      `${this.basePath(assistantId)}/suggestions/${suggestionId}`,
      {
        params: {
          observations_page: observationsPage,
          observations_per_page: observationsPerPage,
          observation_status: observationStatus,
        },
      }
    );
  }

  review({ assistantId, suggestionId, note = '' }) {
    return axios.patch(
      `${this.basePath(assistantId)}/suggestions/${suggestionId}/review`,
      { note }
    );
  }

  reprocess({ assistantId, suggestionId }) {
    return axios.post(
      `${this.basePath(assistantId)}/suggestions/${suggestionId}/reprocess`
    );
  }

  discard({ assistantId, suggestionId }) {
    return axios.post(
      `${this.basePath(assistantId)}/suggestions/${suggestionId}/discard`
    );
  }

  reprocessObservation({ assistantId, observationId }) {
    return axios.post(
      `${this.basePath(assistantId)}/observations/${observationId}/reprocess`
    );
  }

  discardObservation({ assistantId, observationId }) {
    return axios.post(
      `${this.basePath(assistantId)}/observations/${observationId}/discard`
    );
  }
}

export default new CaptainFaqLearning();
